import { render, staticRenderFns } from "./PageEditorToolbarAddPageBtn.vue?vue&type=template&id=3a9b38a3&scoped=true"
import script from "./PageEditorToolbarAddPageBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarAddPageBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b38a3",
  null
  
)

export default component.exports